<template>
  <div>

    <h1>Home</h1>

    <KadoMenu />

    <template v-if="idToken">

      <!-- session info area -->
      <div class="div-session">
        <font-awesome-icon icon="user" /> : {{ username }} <span @click="signOut">[ <font-awesome-icon icon="sign-out-alt" title="sign out" /> ]</span>
      </div>
      <hr />

    </template>

    <!-- messege area -->
    <div class="div-procMsg-normal" v-if="procMsgNormal">{{ procMsgNormal }}</div>
    <div class="div-procMsg-attention" v-if="procMsgAttention">{{ procMsgAttention }}</div>

    <template v-if="idToken">

      <!-- item create area -->
      <div class="div-create-button">
        <button class="button-normal" type="submit" @click="createMainDataStart">create</button>
      </div>
    </template>

    <template v-if="idToken && localMainData.length >= 1">

      <!-- item filter area -->
      <div class="div-filter">
        <div class="div-filter-bar">
          <font-awesome-icon icon="filter" />
          <input type="text" v-model="filterWord" placeholder="filter the list below">
          <font-awesome-icon icon="times" @click="filterWord=''" />
        </div>
      </div>

      <!-- spinner animation -->
      <div class="div-container-sipnner">
        <div class="div-spinner" v-if="onMainDataLoading">Loading...</div>
      </div>

      <!-- item list area -->
      <table class="table-list">

        <colgroup>
          <col span="1" class="colgroup-col01">
          <col span="1" class="colgroup-col02">
          <col span="1" class="colgroup-col03">
          <col span="1" class="colgroup-col04">
          <col span="1" class="colgroup-col05">
        </colgroup>

        <!--item list header (no-shrink) -->
        <tr class="tr-head">
          <!-- val01 -->
          <th>
            <div class="div-th-col" @click="sortBy('val01')">Col01
              <span v-if="sortArrow('val01')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
              <span v-else-if="sortArrow('val01')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
              <span v-else></span>
            </div>
          </th>
          <!-- val02 -->
          <th>
            <div class="div-th-col" @click="sortBy('val02')">Col02
              <span v-if="sortArrow('val02')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
              <span v-else-if="sortArrow('val02')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
              <span v-else></span>
            </div>
          </th>
          <!-- val03 -->
          <th>
            <div class="div-th-col" @click="sortBy('val03')">Col03
              <span v-if="sortArrow('val03')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
              <span v-else-if="sortArrow('val03')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
              <span v-else></span>
            </div>
          </th>
          <!-- val04 -->
          <th>
            <div class="div-th-col">Col04
            </div>
          </th>
          <!-- action(button) -->
          <th>
            <div class="div-action-reload">
              <div class="div-action">Action</div>
              <div class="div-reload" @click="readMainData"><font-awesome-icon icon="redo" /></div>
            </div>
          </th>
        </tr>

        <!--item list header (shrink) -->
        <div class="div-head-onShrink">
        <tr class="tr-head-onShrink">
          <td class="td-cols-action-reload">
            <div class="div-cols-action-reload">
              <div class="div-cols-action">Cols [
                <!-- val01 -->
                <div class="div-th-col" @click="sortBy('val01')">01
                  <span v-if="sortArrow('val01')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
                  <span v-else-if="sortArrow('val01')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
                  <span v-else></span>
                </div>&nbsp;
                <!-- val02 -->
                <div class="div-th-col" @click="sortBy('val02')">02
                  <span v-if="sortArrow('val02')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
                  <span v-else-if="sortArrow('val02')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
                  <span v-else></span>
                </div>&nbsp;
                <!-- val03 -->
                <div class="div-th-col" @click="sortBy('val03')">03
                  <span v-if="sortArrow('val03')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
                  <span v-else-if="sortArrow('val03')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
                  <span v-else ></span>
                </div>&nbsp;
                <!-- val04 -->
                <div class="div-th-col">04
                </div>
                ] / Action
              </div>
              <div class="div-cols-reload" @click="readMainData"><font-awesome-icon icon="redo" /></div>
            </div>
          </td>
        </tr>
        </div>

        <!--item list body -->
        <tr v-for="item in localMainDataArranged" :key="item.id" class="tr-body">
          <!-- val01 -->
          <td class="td-prime-col">
            <div class="div-prime-col">
              <label class="label-prime-col" @click="switchShowImage(item)">{{ item.val01 }}</label>
              <img class="img-prime-col" v-if="item.onReadImage" :src="item.imgSrc" />
            </div>
          </td>
          <!-- val02 -->
          <td class="td-sub-col">
            <label>{{ item.val02 }}</label>
          </td>
          <!-- val03 -->
          <td class="td-sub-col">
            <label>{{ item.val03 }}</label>
          </td>
          <!-- val04 -->
          <td class="td-sub-col">
            <div v-html="tagShaped(item.val04)"></div>
          </td>
          <!-- action(button) -->
          <td class="td-sub-col">
            <button class="button-normal" @click="deleteMainDataStart(item)">delete</button>
            <button class="button-normal" @click="updateMainDataStart(item)">update</button>
          </td>
        </tr>

      </table>

    </template>

    <ModalCreate v-if="mainDataOnCreating"
      :modalTagsForAutoComplete="tagsForAutoComplete"
      @modalCanceled="createMainDataCanceled"
      @modalFixed="createMainDataFixed" />

    <ModalDelete v-if="mainDataOnDeleting"
      :modalItem="mainDataForDelete"
      @modalCanceled="deleteMainDataCanceled"
      @modalFixed="deleteMainDataFixed" />

    <ModalUpdate v-if="mainDataOnUpdating"
      :modalItem="mainDataForUpdate"
      :modalTagsForAutoComplete="tagsForAutoComplete"
      @modalCanceled="updateMainDataCanceled"
      @modalFixed="updateMainDataFixed" />

  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// データモジュール
import { MyData } from '@/my-modules/my-data'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'
// コンポーネント：データ追加用モーダルページ
import ModalCreate from '@/components/ModalCreate.vue'
// コンポーネント：データ削除用モーダルページ
import ModalDelete from '@/components/ModalDelete.vue'
// コンポーネント：データ更新用モーダルページ
import ModalUpdate from '@/components/ModalUpdate.vue'

export default {
  name: 'Home',

  components: {
    KadoMenu,
    ModalCreate,
    ModalDelete,
    ModalUpdate
  },

  data: function () {
    return {
      localMainData: [],
      onMainDataLoading: false,
      mainDataOnCreating: false,
      mainDataOnDeleting: false,
      mainDataForDelete: '',
      mainDataOnUpdating: false,
      mainDataForUpdate: '',
      sortKey: 'val01',
      sortAsc: true,
      filterWord: '',
      procMsgNormal: null,
      procMsgAttention: null,
      username: '',
      idToken: '',
      tagsForAutoComplete: []
    }
  },

  mounted: function () {
    this.readMainData()
  },

  methods: {

    /* =================================================================================
     * signOut
     *   サインアウト
     * ============================================================================== */
    signOut () {
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: Start', mc.LOG_TYPE_I) : (() => { })()
      const myAuth = new MyAuth()
      myAuth.signOut()
      this.username = ''
      this.idToken = ''
      this.$router.push('/auth/signin')
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
          setTimeout(() => { this.$router.push('/auth/signin') }, mc.MSG_TIMEOUT)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * readMainData
     *  メインデータを取得して表示
     * ============================================================================== */
    async readMainData () {
      mc.LOG_LEVEL ? console.log('%c info: Method=readMainData: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      this.onMainDataLoading = true
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { this.onMainDataLoading = false; return false }
        const myData = new MyData()
        const res = await myData.readMainData(this.idToken)
        if (res.status === 'OK') {
          this.localMainData = res.content.data.Items
          this.localMainData.forEach(function (item) {
            item.onReadImage = false
            item.imgSrc = ''
          }, this)
          this.tagsForAutoComplete = this.tagsDistincted()
        } else if (res.status === 'NODATA') {
          this.WriteProcMsg('normal', 'No data.')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=readMainData: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to get the data at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=readMainData: End', mc.LOG_TYPE_I) : (() => { })()
      this.onMainDataLoading = false
    },

    /* =================================================================================
     * tagShaped
     *   タグ表示用の装飾タグを付ける
     * ============================================================================== */
    tagShaped (val) {
      let _tagShaped = ''
      if (val) {
        for (const elem of val.split(',')) {
          if (elem) {
            _tagShaped = `${_tagShaped}<span class='tagShaped'>${elem}</span>`
          }
        }
      }
      return _tagShaped
    },

    /* =================================================================================
     * tagsDistincted
     *   メインデータ全件からタグのユニークリストを取得
     *   (コンポーネントvue-tags-inputのタグ入力候補リストの元になる)
     * ============================================================================== */
    tagsDistincted () {
      const _tagsDistincted = []
      this.localMainData.forEach(function (item) {
        if (item.val04) {
          for (const elem of item.val04.split(',')) {
            if (elem) {
              if (!_tagsDistincted.find(el => { return el.text === elem })) {
                _tagsDistincted.push({ text: elem })
              }
            }
          }
        }
      }, this)
      return _tagsDistincted
    },

    /* =================================================================================
     * sortBy
     *   各カラムの昇順・降順を切替
     * ============================================================================== */
    sortBy (key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc
      } else {
        this.sortAsc = true
      }
      this.sortKey = key
    },

    /* =================================================================================
     * sortArrow
     *   各カラムの昇順・降順を示すフォントの表を切替
     * ============================================================================== */
    sortArrow (key) {
      let _sortArrow
      if (this.sortKey === key) {
        if (this.sortAsc) {
          _sortArrow = 'asc'
        } else {
          _sortArrow = 'desc'
        }
      } else {
        _sortArrow = ''
      }
      return _sortArrow
    },

    /* =================================================================================
     * createMainDataStart
     *   メインデータ追加処理を開始する(処理中フラグを立ててモーダルページを表示)
     * ============================================================================== */
    createMainDataStart () {
      this.mainDataOnCreating = true
    },

    /* =================================================================================
     * createMainDataCanceled
     *   メインデータ追加処理の中止を受け、処理中フラグを下げてモーダルページを非表示
     * ============================================================================== */
    createMainDataCanceled () {
      this.mainDataOnCreating = false
      // メインデータを再読み込み
      this.readMainData()
    },

    /* =================================================================================
     * createMainDataFixed
     *   メインデータ追加処理の完了を受け、処理中フラグを下げてモーダルページを非表示
     * ============================================================================== */
    createMainDataFixed () {
      this.mainDataOnCreating = false
      // メインデータを再読み込み
      this.readMainData()
    },

    /* =================================================================================
     * deleteMainDataStart
     *   メインデータ削除処理を開始する(処理中フラグを立ててモーダルページを表示)
     * ============================================================================== */
    deleteMainDataStart (targetItem) {
      this.mainDataForDelete = targetItem
      this.mainDataOnDeleting = true
    },

    /* =================================================================================
     * deleteMainDataCanceled
     *   メインデータ削除処理の中止を受け、処理中フラグを下げてモーダルページを非表示
     * ============================================================================== */
    deleteMainDataCanceled () {
      this.mainDataOnDeleting = false
      this.mainDataForDelete = ''
      // メインデータを再読み込み
      this.readMainData()
    },

    /* =================================================================================
     * deleteMainDataFixed
     *   メインデータ削除処理の完了を受け、処理中フラグを下げてモーダルページを非表示
     * ============================================================================== */
    deleteMainDataFixed () {
      this.mainDataOnDeleting = false
      this.mainDataForDelete = ''
      // メインデータを再読み込み
      this.readMainData()
    },

    /* =================================================================================
     * updateMainDataStart
     *   メインデータ更新処理を開始する(処理中フラグを立ててモーダルページを表示)
     * ============================================================================== */
    updateMainDataStart (targetItem) {
      this.mainDataForUpdate = targetItem
      this.mainDataOnUpdating = true
    },

    /* =================================================================================
     * updateMainDataCanceled
     *   メインデータ更新処理の中止を受け、処理中フラグを下げてモーダルページを非表示
     * ============================================================================== */
    updateMainDataCanceled () {
      this.mainDataOnUpdating = false
      this.mainDataForUpdate = ''
      // メインデータを再読み込み
      this.readMainData()
    },

    /* =================================================================================
     * updateMainDataFixed
     *   メインデータ更新処理の完了を受け、処理中フラグを下げてモーダルページを非表示
     * ============================================================================== */
    updateMainDataFixed (targetItem) {
      this.mainDataOnUpdating = false
      this.mainDataForUpdate = ''
      // メインデータを再読み込み
      this.readMainData()
    },

    /* =================================================================================
     * メソッド switchShowImage
     *   画像ファイルを表示・非表示
     * ============================================================================== */
    async switchShowImage (targetItem) {
      mc.LOG_LEVEL ? console.log('%c info: Method=switchShowImage: Start', mc.LOG_TYPE_I) : (() => { })()
      const index = this.localMainData.indexOf(targetItem)
      const targetLocalMainData = this.localMainData[index]
      // 表示状態→非表示状態へ
      if (this.localMainData[index].onReadImage) {
        targetLocalMainData.imgSrc = ''
        targetLocalMainData.onReadImage = false
        this.localMainData.splice(index, 1, targetLocalMainData)
      // 非表示状態→表示状態へ
      } else {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const targetId = this.localMainData[index].id
        try {
          const myData = new MyData()
          const res = await myData.readImageData(this.idToken, targetId)
          if (res.status === 'OK') {
            targetLocalMainData.imgSrc = `data:image/png;base64,${this.encodeImageFile(res.content.Body)}`
            targetLocalMainData.onReadImage = true
            this.localMainData.splice(index, 1, targetLocalMainData)
          }
        // モジュールmyData(async)からの例外エラーをcatch
        } catch (e) {
          mc.LOG_LEVEL ? console.log('%c error: Method=switchShowImage: e:', mc.LOG_TYPE_E, e) : (() => { })()
          this.WriteProcMsg('attention', 'Failed to get image at the moment, possibly image may not exist.')
        }
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=switchShowImage: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * encodeImageFile
     *   取得した画像ファイルをエンコードする
     * ============================================================================== */
    encodeImageFile (data) {
      const str = data.reduce(function (a, b) { return a + String.fromCharCode(b) }, '')
      return btoa(str).replace(/.{76}(?=.)/g, '$&\n')
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  },

  computed: {
    /* =================================================================================
     * localMainDataArranged
     *   メインデータをフィルタ・ソートした結果を返す
     * ============================================================================== */
    localMainDataArranged () {
      const filterWordLc = this.filterWord && this.filterWord.toLocaleLowerCase()
      let _localMainDataArranged
      if (filterWordLc) {
        _localMainDataArranged = this.localMainData.filter(record => {
          return record.val01.toLocaleLowerCase().indexOf(filterWordLc) !== -1 ||
          record.val02.toLocaleLowerCase().indexOf(filterWordLc) !== -1 ||
          record.val03.toLocaleLowerCase().indexOf(filterWordLc) !== -1 ||
          record.val04.toLocaleLowerCase().indexOf(filterWordLc) !== -1
        })
      } else {
        _localMainDataArranged = this.localMainData
      }
      if (this.sortKey !== '') {
        let set = 1
        if (this.sortAsc) {
          set = 1
        } else {
          set = -1
        }
        _localMainDataArranged.sort(
          (a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) return -1 * set
            if (a[this.sortKey] > b[this.sortKey]) return 1 * set
            return 0
          }
        )
        return _localMainDataArranged
      } else {
        return _localMainDataArranged
      }
    }
  }
}
</script>

<style scoped lang="scss">
$BASE_COLOR: #055555;
$ACTIVE_COLOR: #08a702;
$FILTERBOX_BG_INACTIVE_COLOR: #e8e8e8;
$FILTERBOX_BG_ACTIVE_COLOR: #e4e4e136;
$FILTERBOX_BORDER_INACTIVE_COLOR: #055555;
$FILTERBOX_BORDER_ACTIVE_COLOR: #08a702;
$PLACEHOLDER_COLOR: #05555554;
$TABLE_ROW_PRIME_BG_COLOR: #ebebeb;
$TABLE_ROW_PRIME_BORDER_COLOR: #055555;
$TABLE_ROW_SUB_BG_COLOR: #e4e4e136;
$TABLE_ROW_SUB_BORDER_COLOR: #05555554;

.div-session {
  text-align: right;
}
.fa-sign-out-alt {
  cursor: pointer;
}
.div-create-button {
  text-align: right;
}
.div-filter {
  text-align: right;
  position: sticky;
  top: 0;
  background-color: #fff;
}
.div-filter-bar {
  height: 2.5em;
  max-width: 22em;
  margin-top: 0.75em;
  margin-bottom: 0.5em;
  margin-left: auto;
  border: 1.5px solid #fff;
  border-bottom: 2.5px solid $FILTERBOX_BORDER_INACTIVE_COLOR;
  outline: none;
  background-color: $FILTERBOX_BG_INACTIVE_COLOR;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.div-filter-bar:focus-within {
  border: 1.5px solid $FILTERBOX_BORDER_ACTIVE_COLOR;
  border-bottom: 2.5px solid $FILTERBOX_BORDER_ACTIVE_COLOR;
  background-color: $FILTERBOX_BG_ACTIVE_COLOR;
}
.fa-filter {
  padding: 0.1em 0.1em;
  font-size: 1.2em;
  color: $BASE_COLOR;
}
.fa-times {
  padding: 0.1em 0.1em;
  font-size: 1.5em;
  color: $BASE_COLOR;
  display: inline;
  cursor: pointer;
}
.div-filter-bar input {
  width: 100%;
  border: none;
  font-size: 1em;
  background-color: transparent;
  outline: none;
}
.div-filter-bar input::placeholder {
  color: $PLACEHOLDER_COLOR;
}
.table-list {
  width: 100%;
}
.table-list .colgroup-col01,
.table-list .colgroup-col02 {
  width: 18%;
}
.table-list .colgroup-col03 {
  width: 30%;
}
.table-list .colgroup-col04 {
  width: 15%;
}
.table-list th,
.table-list td {
  padding: 0.25em 0.5em;
}
.table-list th {
  text-align: center;
  font-weight: normal;
  color: #fff;
  background: $BASE_COLOR;
  position: sticky;
  top: 2.55em;
  line-height: 1.25em;
}
.div-th-col {
  display:inline-block;
  cursor: pointer;
}
.div-action-reload {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.div-action {
  padding: 0 0.3em 0 0;
}
.div-reload {
  padding: 0 0 0 0.3em;
  display:inline-block;
  cursor: pointer;
}
.fa-redo {
  color: #fff;
  font-size:1.2em;
}
.fa-redo:active {
  color: $ACTIVE_COLOR;
  font-size:1.2em;
}
.tr-body:hover td {
  background: $TABLE_ROW_SUB_BG_COLOR;
}
.table-list td {
  line-height: 1.5em;
  border-bottom: 1px dashed $TABLE_ROW_SUB_BORDER_COLOR;
  vertical-align: top;
}
.table-list td.td-prime-col,
.table-list td.td-sub-col:not(:last-child) {
  text-align: left;
}
.table-list td.td-sub-col:last-child {
  text-align: center;
  width: auto;
}
.div-prime-col {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.label-prime-col {
  cursor: pointer;
}
.img-prime-col {
  align-self: flex-start;
  max-width: 100%;
}
.div-imgUpdateDel {
  margin-top: 0.25em;
  display: flex;
  flex-flow: row wrap;
}
.input-imgUpdateDel {
  max-width: 16.5em;
  margin-bottom: 0.2em;
  font-size: 0.8em;
}
.div-imgUpdateDel-Buttons {
  display: flex;
  flex-direction: row;
}
::v-deep .tagShaped {
  display: inline-block;
  margin: 0.2em 0.2em;
  padding: 0.1em 0.4em;
  border-radius: 0.2em;
  border: none;
  line-height: 1.35em;
  background-color: #237720a4;
  color: #fff;
  font-size: 0.85em;
  white-space:nowrap;
}
.tr-head-onShrink {
  display: none;
}
/* ↓ spinner ↓ */
.div-container-sipnner{
  display: flex;
  justify-content: center;
}
.div-spinner {
  z-index: 49;
  font-size: 10px;
  text-indent: -9999em;
  margin-top:5em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: #3a7c0e;
  background: -moz-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: -webkit-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: -o-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: -ms-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: linear-gradient(to right, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  position: absolute;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.div-spinner:before {
  width: 50%;
  height: 50%;
  background: #3a7c0e;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
}
.div-spinner:after {
  background: #f1f4f4;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
/* ↑ spinner ↑ */

@media screen and (max-width: 559px) {
  .div-filter {
    position: static;
    /*
    position: sticky  -webkit-sticky;
    top: 0;
    */
  }
  .div-filter-bar {
    max-width: 100%;
  }
  .table-list .colgroup-col01,
  .table-list .colgroup-col02,
  .table-list .colgroup-col03,
  .table-list .colgroup-col04 {
    width: 100%;
  }
  .tr-head {
    display: none;
  }
  .tr-head-onShrink {
    display: block;
    padding: 0;
    /*
    position: sticky -webkit-sticky;
    top: 0em;
    */
  }
  .tr-head-onShrink td {
    line-height: 2em;
  }
  .table-list td.td-cols-action-reload {
    width: 100%;
    text-align: center;
    font-weight: normal;
    color: #fff;
    background: $BASE_COLOR;
    padding: 0;
  }
  .div-cols-action-reload {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }
  .div-cols-action {
    padding: 0 0.25em;
    color: #fff;
  }
  .div-cols-reload {
    padding: 0 0.25em;
    color: #fff;
    display:inline-block;
    cursor: pointer;
  }
  .fa-redo {
    color: #fff;
    font-size:large;
  }
  .fa-redo:active {
    color: $ACTIVE_COLOR;
    font-size:large;
  }
  .table-list td {
    display: block;
  }
  .table-list td::before {
    content: attr(td-sub-col);
    display: block;
  }
  .td-prime-col {
    border-top: 2px solid $TABLE_ROW_PRIME_BORDER_COLOR;
    background: $TABLE_ROW_PRIME_BG_COLOR;
    width: 100%;
  }
  .tr-body:hover .td-prime-col {
    background: $TABLE_ROW_PRIME_BG_COLOR;
  }
  .table-list td.td-prime-col,
  .table-list td.td-sub-col:not(:last-child) {
    text-align: center;
    width: initial;
  }
  .img-prime-col {
    margin-left:auto;
    margin-right:auto;
  }
}
</style>
